<template>
  <div class="proWhy2 reveal px-10vw __scroll-clip">

    <div class="topwhy">
        <div>
            MIS LYNX: <br/>NextGen Simplicity
        </div>
        <div>
            MIS LYNX is an all-in-one implant system that takes Simplicity to new heights. With single-use drills included with every implant, the MIS CLEAR™ wet surface, and a broad prosthetic range, MIS LYNX offers clinicians a reliable and valuable choice.
            <br/><br/>
            <p>
              <b>MIS LYNX might not be registered or available in every country/region.</b>
              <br/>
              Warning: Risks associated with the implant procedure include but are not limited to aspiration, inflammation, nerve damage, perforation of the sinus, and pain. For a full list of risks, refer to the device Instructions for Use. Be sure to discuss with your patient about all potential risks associated with implants and the procedure.
            </p>
        </div>
    </div>

    <ul>
        <li v-for="item in items" :key="item.title">
            <!-- <img :src="item.img" :title="item.title" /> -->
            <h5>{{item.title}}</h5>
            <p>{{item.summary}}</p>
        </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {  },
  data() {
    return {
        items:[
            {img:"img/icons/adaptive_placement.png",title:"Adaptive Placement for Surgical Simplicity",summary:"MIS LYNX’s distinctive design promotes flexibility and reliability in implant procedures."},
            {img:"img/icons/single_use.png",title:"Single-Use Drills with Every Implant for Surgical Efficiency",summary:"MIS LYNX includes sharp and sterile drills in every package, providing a simplified drilling procedure while maintaining strict hygiene protocols."},
            {img:"img/icons/versatility.png",title:"Restorative Versatility for Esthetics Excellence",summary:"MIS LYNX offers a wide range of prosthetics, reducing workflow complexity by streamlining the process and empowering flexible, efficient, and esthetic results."}        
        ]
    };
  },
  props: {
    sectionData:{}
  },
  computed: {
    ...mapGetters(["localeString"]),

    getMainPageLink()
    {
      return this.parsedLocaleString+"/science/research-library?categories=Clinical%20Cases";
      //return this.parsedLocaleString+"/research-and-development/research-library?categories=Clinical%20Cases";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
        //alert(this.sectionData.items[0].title);
      return this.sectionData.items;
    }
  },
  methods: 
  {
    //...mapActions(["setGalleryIndex", "setGalleryChildren"]),
  }
};
</script>

<style scoped>

    .proWhy2
    {
        width: 100%;
        min-height: 200px;
        background: #f6f6f6;
        color: #fff;
        padding: 5vw 8vw;
        border-radius: 25px;
    }
    .proWhy2 .psTitle
    {
        color: #fff;
        width: 100%;
    }

    .topwhy
    {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 2fr; /* Creates 1/3 and 2/3 ratio */
      gap: 2vw;
    }
    .topwhy > div:nth-child(1)
    {
      font-size: 32px;line-height: 33px;color: #202020;font-weight: 300 !important;
      
    }
    .topwhy > div:nth-child(2)
    {
      font-size: 14px;
      color: #202020;
      width: 65%;
    }
    .topwhy > div:nth-child(2) p
    {
      font-size: 11px;
    }


    .proWhy2 ul
    {
        padding-top: 50px;
        list-style: none;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 2vw;
    }
    .proWhy2 ul li
    {
        text-align:left;
        /* background:transparent;  */
        /* background: #fff; */        

        border-left: solid 1px #b5b5b5;
        border-left-style: dotted;
        /* border-style: dotted; */
        padding: 1.5vw 2.5vw 2vw 2.5vw;
        /* border-radius: 25px;  */
    }
    .proWhy2 ul li img
    {
        height: 50px;
        width: auto;
    }
    .proWhy2 ul li h5
    {
        padding-top: 10px;
        font-size: 24px;
        color: #369cde;
        font-weight: 300 !important;
        width: 100% !important;
    }
    .proWhy2 ul li p
    {
        padding-top: 20px;
        font-size: 14px;
        color: #202020;
    }





    @media (hover: hover) {
    }

    @media screen and (max-width: 815px)
    {
        .proWhy2
        {
            padding: 16vw 12vw;
        }
        .proWhy2 ul
        {
            grid-template-columns: 1fr;

        }
    }


    @media only screen and (min-width:2000px)
    {
    }
</style>
